import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: ""
}
const _hoisted_2 = { class: "p-5 bg-white rounded-lg mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-primary-500 mb-6" }, "Patient Details", -1)
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_5 = { class: "col-span-full lg:col-span-6 space-y-2.5 lg:mb-14" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "First Name", -1)
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Middle Name", -1)
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Last Name", -1)
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "col-span-full lg:col-span-6 space-y-2.5 lg:mb-14" }
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Date of Birth", -1)
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "flex justify-between" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Sex", -1)
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = { class: "flex justify-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Nationality", -1)
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_26 = { class: "flex justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "Civil Status", -1)
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = { class: "flex justify-between" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Email Address", -1)
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_33 = { class: "flex justify-between" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "Telephone Number", -1)
const _hoisted_35 = { class: "font-bold" }
const _hoisted_36 = { class: "flex justify-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, "Cellphone Number", -1)
const _hoisted_38 = { class: "font-bold" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500 mb-6" }, "Local Address", -1)
const _hoisted_41 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_42 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_43 = { class: "flex justify-between" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, "Province", -1)
const _hoisted_45 = { class: "font-bold" }
const _hoisted_46 = { class: "flex justify-between" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, "Barangay", -1)
const _hoisted_48 = { class: "font-bold" }
const _hoisted_49 = { class: "flex justify-between" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, "No./Bldg.", -1)
const _hoisted_51 = { class: "font-bold" }
const _hoisted_52 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_53 = { class: "flex justify-between" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, "City/Municipality", -1)
const _hoisted_55 = { class: "font-bold" }
const _hoisted_56 = { class: "flex justify-between" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, "Street", -1)
const _hoisted_58 = { class: "font-bold" }
const _hoisted_59 = { class: "flex justify-between" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, "ZIP Code", -1)
const _hoisted_61 = { class: "font-bold" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500 mb-6" }, "Permanent Address", -1)
const _hoisted_64 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_65 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_66 = { class: "flex justify-between" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", null, "Province", -1)
const _hoisted_68 = { class: "font-bold" }
const _hoisted_69 = { class: "flex justify-between" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, "Barangay", -1)
const _hoisted_71 = { class: "font-bold" }
const _hoisted_72 = { class: "flex justify-between" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", null, "No./Bldg.", -1)
const _hoisted_74 = { class: "font-bold" }
const _hoisted_75 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_76 = { class: "flex justify-between" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", null, "City/Municipality", -1)
const _hoisted_78 = { class: "font-bold" }
const _hoisted_79 = { class: "flex justify-between" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", null, "Street", -1)
const _hoisted_81 = { class: "font-bold" }
const _hoisted_82 = { class: "flex justify-between" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", null, "ZIP Code", -1)
const _hoisted_84 = { class: "font-bold" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_86 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_87 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_88 = { class: "flex justify-between" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", null, "PhilHealth No", -1)
const _hoisted_90 = { class: "font-bold" }
const _hoisted_91 = { class: "p-5 bg-white rounded-lg mb-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-primary-500 mb-6" }, "Occupation", -1)
const _hoisted_93 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_94 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_95 = { class: "flex justify-between" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", null, "Title", -1)
const _hoisted_97 = { class: "font-bold" }
const _hoisted_98 = { class: "flex justify-between" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("p", null, "Contact Number", -1)
const _hoisted_100 = { class: "font-bold" }
const _hoisted_101 = { class: "flex justify-between" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("p", null, "Company Email Address", -1)
const _hoisted_103 = { class: "font-bold" }
const _hoisted_104 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_105 = { class: "flex justify-between" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("p", null, "Company Name", -1)
const _hoisted_107 = { class: "font-bold" }
const _hoisted_108 = { class: "flex justify-between" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", null, "Address", -1)
const _hoisted_110 = { class: "font-bold text-right max-w-[70%]" }
const _hoisted_111 = { class: "p-5 bg-white rounded-lg mb-2" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-primary-500 mb-6" }, "Person to notify in case of emergency", -1)
const _hoisted_113 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0" }
const _hoisted_114 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_115 = { class: "flex justify-between" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", null, "Name", -1)
const _hoisted_117 = { class: "font-bold" }
const _hoisted_118 = { class: "flex justify-between" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("p", null, "Contact Number", -1)
const _hoisted_120 = { class: "font-bold" }
const _hoisted_121 = { class: "col-span-full lg:col-span-6 space-y-2.5" }
const _hoisted_122 = { class: "flex justify-between" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("p", null, "Relationship", -1)
const _hoisted_124 = { class: "font-bold" }
const _hoisted_125 = { class: "flex justify-between" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("p", null, "Email Address", -1)
const _hoisted_127 = { class: "font-bold" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-400 text-sm" }, [
  /*#__PURE__*/_createTextVNode("If you want to make any changes to any of the information shown above, you may contact us via our trunkline "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:(02) 736-85239",
    class: "font-bold"
  }, "(02) 736-85239"),
  /*#__PURE__*/_createTextVNode(".")
], -1)

import PortalLayout from '@/layouts/PortalLayout.vue';
import MedicalRecordForm from './MedicalRecordForm.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import VueBarcode from '@chenfengyuan/vue-barcode';

import patient from "@/classes/UserData";
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const patientData = computed(() => patient.getCurrentUser())

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)

const hasRecord = computed(() => {
    return patientData.value.last_name !== null
        && patientData.value.first_name !== null
        && patientData.value.cellphone_number !== null
        && patientData.value.civil_status !== null
        && patientData.value.sex !== null
        && patientData.value.nationality !== null
        && patientData.value.job_title !== null
        && patientData.value.birthdate !== null
        && patientData.value.email_address !== null
        && patientData.value.barangay !== null
        && patientData.value.city !== null
        && patientData.value.province !== null
        && patientData.value.company_name !== null
        && patientData.value.company_address !== null
        && patientData.value.contact_person_name !== null
        && patientData.value.contact_person_relationship !== null
        && patientData.value.contact_person_number !== null
        && patientData.value.permanent_street !== null
        && patientData.value.permanent_barangay !== null
        && patientData.value.permanent_city !== null
        && patientData.value.permanent_province !== null
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { title: "Your Medical Record" }, {
    fields: _withCtx(() => [
      (hasRecord.value)
        ? (_openBlock(), _createBlock(_unref(VueBarcode), {
            key: 0,
            value: patientData.value.hospital_no,
            options: { displayValue: true },
            class: "mr-6"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!hasRecord.value)
        ? (_openBlock(), _createBlock(MedicalRecordForm, { key: 0 }))
        : _createCommentVNode("", true),
      (hasRecord.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, _toDisplayString(patientData.value.first_name ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", _hoisted_11, _toDisplayString(patientData.value.middle_name ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(patientData.value.last_name ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", _hoisted_18, _toDisplayString(patientData.value.birthdate ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("p", _hoisted_21, _toDisplayString(patientData.value.sex ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("p", _hoisted_24, _toDisplayString(patientData.value.nationality ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("p", _hoisted_28, _toDisplayString(patientData.value.civil_status ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("p", _hoisted_31, _toDisplayString(patientData.value.email_address ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("p", _hoisted_35, _toDisplayString(patientData.value.telephone_number ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("p", _hoisted_38, "+63 " + _toDisplayString(patientData.value.cellphone_number ?? '-'), 1)
                  ])
                ])
              ]),
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("p", _hoisted_45, _toDisplayString(patientData.value.province ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("p", _hoisted_48, _toDisplayString(patientData.value.barangay ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("p", _hoisted_51, _toDisplayString(patientData.value.building_number ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("p", _hoisted_55, _toDisplayString(patientData.value.city ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("p", _hoisted_58, _toDisplayString(patientData.value.street ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("p", _hoisted_61, _toDisplayString(patientData.value.zip_code ?? '-'), 1)
                  ])
                ])
              ]),
              _hoisted_62,
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("p", _hoisted_68, _toDisplayString(patientData.value.permanent_province ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("p", _hoisted_71, _toDisplayString(patientData.value.permanent_barangay ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("p", _hoisted_74, _toDisplayString(patientData.value.permanent_building_number ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("p", _hoisted_78, _toDisplayString(patientData.value.permanent_city ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createElementVNode("p", _hoisted_81, _toDisplayString(patientData.value.permanent_street ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("p", _hoisted_84, _toDisplayString(patientData.value.permanent_zip_code ?? '-'), 1)
                  ])
                ])
              ]),
              _hoisted_85,
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("p", _hoisted_90, _toDisplayString(patientData.value.philhealth_number ?? '-'), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _createElementVNode("p", _hoisted_97, _toDisplayString(patientData.value.job_title ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _hoisted_99,
                    _createElementVNode("p", _hoisted_100, "+63 " + _toDisplayString(patientData.value.company_contact_no ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _hoisted_102,
                    _createElementVNode("p", _hoisted_103, _toDisplayString(patientData.value.company_email ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _createElementVNode("p", _hoisted_107, _toDisplayString(patientData.value.company_name ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("p", _hoisted_110, _toDisplayString(patientData.value.company_address ?? '-'), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _hoisted_112,
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _hoisted_116,
                    _createElementVNode("p", _hoisted_117, _toDisplayString(patientData.value.contact_person_name ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _hoisted_119,
                    _createElementVNode("p", _hoisted_120, "+63 " + _toDisplayString(patientData.value.contact_person_number ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _hoisted_123,
                    _createElementVNode("p", _hoisted_124, _toDisplayString(patientData.value.contact_person_relationship ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("p", _hoisted_127, _toDisplayString(patientData.value.contact_person_email ?? '-'), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_128
          ]))
        : _createCommentVNode("", true),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})